import { render, staticRenderFns } from "./VehicleSubstitution.vue?vue&type=template&id=2a8c17d8&scoped=true"
import script from "./VehicleSubstitution.vue?vue&type=script&lang=js"
export * from "./VehicleSubstitution.vue?vue&type=script&lang=js"
import style0 from "./VehicleSubstitution.vue?vue&type=style&index=0&id=2a8c17d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c17d8",
  null
  
)

export default component.exports